export function printElement<T extends HTMLElement>(containerRef: React.RefObject<T>): void {
    if (!containerRef.current) return;
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const { document: doc } = printWindow;
    const { head, body } = doc;
    const extraStyle = doc.createElement('style');
    const clonedContent = containerRef.current.cloneNode(true) as T;

    // Normalize layout for printing
    Object.assign(clonedContent.style, {
        height: 'auto',
        maxHeight: 'none',
        overflow: 'visible',
        backgroundColor: 'unset',
    });

    // Copy existing stylesheets
    document.querySelectorAll('style, link[rel="stylesheet"]').forEach((styleNode) => {
        head.appendChild(styleNode.cloneNode(true));
    });

    // Print overrides
    extraStyle.textContent = `
    html, body {
        padding: 0;
        height: auto !important;
        overflow: visible !important;
        background: unset;
    }`;

    head.appendChild(extraStyle);
    body.appendChild(clonedContent);

    setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }, 300);
}
